import { useContractReads } from "wagmi";
import useAccount from "@/hooks/useAccount";
import { claimerContracts } from "@/services/contract";

export default function useClaimerContract(chainId: number) {
  const { address } = useAccount();
  const contract = claimerContracts[chainId];
  const { data } = useContractReads({
    watch: false,
    scopeKey: "claimer-contract",
    contracts: [
      {
        ...contract,
        functionName: "tokenIdCounter",
      },
      {
        ...contract,
        functionName: "balanceOf",
        args: [address as string],
      },
      {
        ...contract,
        functionName: "claimerRoles",
        args: [address],
      },
    ] as any,
  });

  const balance = (data?.[1]?.result as bigint) || 0n;

  return {
    quantity: Number(data?.[0]?.result || 0),
    isReady: !!data,
    balance,
    minted: balance > 0n,
    role: Number(data?.[2]?.result),
  };
}
